import React from 'react';
import {
    Box,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    IconButton,
    Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { LABELS } from './PlanStatusTab.constants';

export const ApprovalCommentPopup = ({ open, onClose, title, comment }) => (
    <Dialog
        open={open}
        onClose={onClose}
        maxWidth="sm"
        fullWidth
        aria-labelledby="approval-comment-dialog-title"
        PaperProps={{
            sx: styles.dialogPaper
        }}
    >
        <DialogTitle
            id="approval-comment-dialog-title"
            sx={styles.dialogTitle}
        >
            {title}
            <IconButton
                aria-label="close"
                onClick={onClose}
                sx={styles.closeButton}
            >
                <CloseIcon />
            </IconButton>
        </DialogTitle>
        <DialogContent sx={styles.dialogContent}>
            <Box sx={styles.commentBox}>
                <Typography variant="body1">
                    {comment || LABELS.NO_COMMENT}
                </Typography>
            </Box>
        </DialogContent>
        <DialogActions sx={styles.dialogActions}>
            <Button
                onClick={onClose}
                variant="contained"
                color="primary"
                sx={styles.actionButton}
            >
                {LABELS.CLOSE}
            </Button>
        </DialogActions>
    </Dialog>
);

const styles = {
    dialogPaper: {
        borderRadius: '8px',
        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.15)',
    },
    dialogTitle: {
        bgcolor: '#f0f6ff',
        color: 'primary.main',
        fontWeight: 600,
        borderBottom: '1px solid #e0e0e0',
        py: 1.5
    },
    closeButton: {
        position: 'absolute',
        right: 8,
        top: 8,
        color: '#757575',
        '&:hover': {
            color: 'primary.main',
            bgcolor: 'rgba(25, 118, 210, 0.08)'
        }
    },
    dialogContent: {
        pb: 0,
        pt: 0,
        px: 2,
        bgcolor: '#f8f9fa'
    },
    commentBox: {
        mt: 1.5,
        maxHeight: '50vh',
        overflow: 'auto',
        bgcolor: '#f5f5f5',
        p: 2,
        borderRadius: '4px',
        border: '1px solid #e0e0e0',
        wordBreak: 'break-word',
        whiteSpace: 'pre-wrap'
    },
    dialogActions: {
        bgcolor: '#f8f9fa',
        py: 1.5,
        px: 2
    },
    actionButton: {
        textTransform: 'none',
        px: 3,
        fontWeight: 500
    }
};